import {
  MaintenanceExecutionTicketsApi,
  MaintenanceExecutionWorkOrdersApi,
} from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const workOrdersApi = new MaintenanceExecutionWorkOrdersApi(config);
export const maintenanceTicketsApi = new MaintenanceExecutionTicketsApi(config);

export const maintenanceExecutionRequestInit = {
  credentials: 'include' as const,
};
